"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissionCard = MissionCard;
exports.MissionCardSkeleton = MissionCardSkeleton;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ItemImageArea_1 = require("../../../components/DataDisplay/ItemImageArea");
var tokens_1 = require("../../tokens");
var GlassCard_1 = require("../GlassCard");
var OnSiteOnlyBadge_1 = require("../OnSiteOnlyBadge");
// カード本体とスケルトンで幅がズレないよう共通の定数にする。
var CARD_WIDTH = 315;
/**
 * 期限切れラベルの背景・文字色。アーティストのtheme.json、v2デザイントークン
 * のいずれにも属さない無彩(色相なし)の固定グレーにする。
 * カード背景 (呼び出し側の background.sub) はアーティストの grey.50 由来で
 * 色相を持つため、同じ色相のグレーだとラベルが背景に埋もれてしまうのを避ける。
 */
var EXPIRED_LABEL_COLORS = {
    light: { bg: '#EEEEEE', text: '#616161' },
    dark: { bg: '#424242', text: '#BDBDBD' },
};
function MissionCard(_a) {
    var title = _a.title, description = _a.description, imageUrl = _a.imageUrl, categoryLabel = _a.categoryLabel, label = _a.label, isOnSiteOnly = _a.isOnSiteOnly, _b = _a.onSiteOnlyLabel, onSiteOnlyLabel = _b === void 0 ? '現地限定' : _b, href = _a.href, onClick = _a.onClick, sx = _a.sx;
    var theme = (0, material_1.useTheme)();
    var expiredColors = theme.palette.mode === 'dark'
        ? EXPIRED_LABEL_COLORS.dark
        : EXPIRED_LABEL_COLORS.light;
    return ((0, jsx_runtime_1.jsx)(GlassCard_1.GlassCard, { bordered: false, cornerRadius: 8, highlight: true, sx: __spreadArray([{ width: CARD_WIDTH }], (Array.isArray(sx) ? sx : [sx]), true), children: (0, jsx_runtime_1.jsxs)(material_1.CardActionArea, { href: href !== null && href !== void 0 ? href : '', onClick: onClick, sx: { p: 4, display: 'flex', flexDirection: 'row', width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.CardContent, { component: material_1.Stack, flex: 1, sx: { p: 0, pr: 4, overflow: 'hidden' }, children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 1, children: [label && ((0, jsx_runtime_1.jsx)(MissionCardLabelChip, { label: label, expiredColors: expiredColors })), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }, variant: "h5", children: title }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", color: "text.secondary", sx: {
                                    wordBreak: 'break-all',
                                    overflowWrap: 'anywhere',
                                    // descriptionが無い場合も含め、常に2行分の高さを確保する
                                    // (caption の line-height: 16px)
                                    minHeight: '32px',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    display: '-webkit-box',
                                    WebkitLineClamp: '2',
                                    WebkitBoxOrient: 'vertical',
                                    whiteSpace: 'normal',
                                }, children: description }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                                    pt: 1,
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    alignItems: 'center',
                                    gap: 2,
                                    minWidth: 0,
                                }, children: [isOnSiteOnly && ((0, jsx_runtime_1.jsx)(OnSiteOnlyBadge_1.OnSiteOnlyBadge, { label: onSiteOnlyLabel, sx: { flexShrink: 0 } })), (0, jsx_runtime_1.jsx)(material_1.Chip, { label: categoryLabel, size: "small", sx: {
                                            minWidth: 0,
                                            flexShrink: 1,
                                            borderRadius: '100px',
                                            typography: 'overline',
                                            bgcolor: 'grey.100',
                                            color: 'text.secondary',
                                            '& .MuiChip-label': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        } })] })] }) }), (0, jsx_runtime_1.jsx)(ItemImageArea_1.ItemImageArea, { size: "x-small", src: imageUrl })] }) }));
}
function MissionCardLabelChip(_a) {
    var label = _a.label, expiredColors = _a.expiredColors;
    switch (label.type) {
        case 'new':
            return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { color: 'white', fontSize: '12px' }, children: label.text }), size: "small", sx: {
                    bgcolor: 'warning.main',
                    borderRadius: '2px',
                    pr: '12px',
                    pl: '12px',
                    height: '20px',
                } }));
        case 'clear':
            return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { color: 'black', fontSize: '12px' }, children: label.text }), size: "small", sx: {
                    bgcolor: 'secondary.main',
                    borderRadius: '2px',
                    height: '20px',
                } }));
        case 'expired':
            return ((0, jsx_runtime_1.jsx)(material_1.Chip, { label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle2", sx: { color: expiredColors.text, fontSize: '12px' }, children: label.text }), size: "small", sx: {
                    bgcolor: expiredColors.bg,
                    borderRadius: '2px',
                    height: '20px',
                } }));
        default:
            return null;
    }
}
function MissionCardSkeleton(_a) {
    var sx = _a.sx;
    return ((0, jsx_runtime_1.jsx)(material_1.Card, { sx: __assign({ width: CARD_WIDTH, borderRadius: "".concat(tokens_1.radius.md, "px") }, sx), children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", spacing: 4, sx: { p: 4, display: 'flex', width: '100%' }, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { flex: 1, spacing: 1, sx: { pr: 4 }, children: [(0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "30%" }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "100%" }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "text", width: "60%" })] }), (0, jsx_runtime_1.jsx)(material_1.Skeleton, { variant: "rectangular", width: 48, height: 76 })] }) }));
}
